<template>
  <div class="page-tag-wrap" ref="headerRef">
    <div class="direct-tag-box">
      <!-- pageTagListNotCloseBox -->
      <PageTag
        v-for="tag in pageTagListNotCloseBox"
        :key="tag.id"
        :tag="tag"
        :ifActive="tag.id === activeTagId"
        :tagIdContextMenuVisible.sync="tagIdContextMenuVisible"
        @close="handleClose"
        @closeOther="handleCloseOther"
        @pin="handlePin"
        @cancelPin="handleCancelPin"
        @refresh="handleRefresh"
        @setActive="handleSetActive"
      >
      </PageTag>

      <!-- pageTagListPinBox -->
      <draggable v-model="pageTagListPinBox">
        <PageTag
          v-for="tag in pageTagListPinBox"
          :key="tag.id"
          :tag="tag"
          :ifActive="tag.id === activeTagId"
          :tagIdContextMenuVisible.sync="tagIdContextMenuVisible"
          @close="handleClose"
          @closeOther="handleCloseOther"
          @pin="handlePin"
          @cancelPin="handleCancelPin"
          @refresh="handleRefresh"
          @setActive="handleSetActive"
        >
        </PageTag>
      </draggable>

      <!-- pageTagListNormalBox -->
      <draggable v-model="pageTagListNormalBox">
        <PageTag
          v-for="tag in pageTagListNormalBox"
          :key="tag.id"
          :tag="tag"
          :ifActive="tag.id === activeTagId"
          :tagIdContextMenuVisible.sync="tagIdContextMenuVisible"
          @close="handleClose"
          @closeOther="handleCloseOther"
          @pin="handlePin"
          @cancelPin="handleCancelPin"
          @refresh="handleRefresh"
          @setActive="handleSetActive"
        >
        </PageTag>
      </draggable>

      <!-- pageTagListAppendBox -->
      <PageTag
        v-for="tag in pageTagListAppendBox"
        :key="tag.id"
        :tag="tag"
        :ifActive="tag.id === activeTagId"
        :tagIdContextMenuVisible.sync="tagIdContextMenuVisible"
        @close="handleClose"
        @closeOther="handleCloseOther"
        @pin="handlePin"
        @cancelPin="handleCancelPin"
        @refresh="handleRefresh"
        @setActive="handleSetActive"
      >
      </PageTag>

      <!-- 更多 -->
      <!-- pageTagListMoreBox -->
      <div v-if="pageTagListMoreBox.length" class="page-tag-more">
        <el-popover
          trigger="click"
          v-model="isShowMoreMenu"
          placement="bottom"
          :append-to-body="false"
          popper-class="g-patch--el-popover--no-padding"
        >
          <template #reference>
            <IconHc
              style="display: inline-block"
              class="icon-btn-like icon-btn-more"
              type="icon-gengduo"
              size="20px"
            ></IconHc>
          </template>

          <div class="menu-wrap menu-wrap-more">
            <div
              v-for="tag in pageTagListMoreBox"
              :key="tag.id"
              class="menu-item"
              @click.stop="handleMoreTagItemClick(tag)"
            >
              <span>{{ tag.title }}</span>
              <IconHc
                style="font-weight: 400"
                class="icon-close"
                type="icon-guanbi"
                size="12px"
                @click.native.stop="handleClose(tag)"
              ></IconHc>
            </div>
          </div>

        </el-popover>

      </div>
    </div>

    <div class="helper-box">
      <el-popover
        v-if="$store.state.user.sidType === 0"
        placement="bottom"
        width="315"
        trigger="hover"
      >
        <div>
          <p class="over-time">到期时间：{{ $store.state.user.overTime }}</p>
          <p class="hover-tip">如需升级，请联系旺店通ERP顾问<el-button type="text"  @click="turnKnownVersion">了解升级版本<i class="el-icon-d-arrow-right double-arrow"></i></el-button></p>
        </div>
        <div class="free-text" type="text" slot="reference">免费版（仅含部分功能）<i class="el-icon-arrow-down"></i></div>
      </el-popover>
      <div v-if="$store.state.user.sidType === 0" class="help-entry"><span class="line-icon">|</span><span class="help-text" @click="turnHelpPage">帮助</span></div>
      <el-popover
        v-if="$store.state.user.sidType === 2"
        placement="bottom"
        width="315"
        trigger="hover"
      >
        <div class="hover-tip">
          <p>1.体验版均为演示数据，仅供参考，注册账号后，可免费试用，查看店铺真实运营情况，<el-button type="text" @click="turnRegistryPage">立即注册<i class="el-icon-d-arrow-right double-arrow"></i></el-button></p>
          <p>2.体验版仅包含部分功能，升级后可使用更多功能，<el-button type="text"  @click="turnKnownVersion">了解升级版本<i class="el-icon-d-arrow-right double-arrow"></i></el-button></p>
        </div>
        <span class="free-text" type="text" slot="reference">体验版（仅含部分功能）<i class="el-icon-arrow-down"></i></span>
      </el-popover>
      <el-button v-if="$store.state.user.sidType === 2" class="free-use" type="primary" size="small" @click="turnRegistryPage">免费试用</el-button>
      <div v-if="$store.state.user.sidType !== 2" style="margin-top: -4px;">
        <HcHuiHelper />
      </div>
    </div>
    <RegisterDialog :visible.sync="isRegisterDialogVisible" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { reloadIframeByBaseAppUrl, startMicroApp } from '@/services/microFeUtil'
import draggable from 'vuedraggable'
import { cancelPinTag, pinTag, removeOtherTags, removePageTagAndBackward, setActiveTagAndNavigate, setHeaderWidth } from '@/services/microFeUtil/pageTagUtils'
import PageTag from './PageTag.vue'
import { debounce } from 'xe-utils'
import HcHuiHelper from './HcHuiHelper'
import RegisterDialog from './RegisterDialog.vue'

export default {
  components: {
    draggable,
    PageTag,
    HcHuiHelper,
    RegisterDialog
  },
  data() {
    return {
      isShowMoreMenu: false,
      tagIdContextMenuVisible: '',
      isRegisterDialogVisible: false
    }
  },
  computed: {
    pageTagListNormalBox: {
      get() {
        const value = this.$store.getters['pageTag/pageTagListNormalBox']
        console.log('pageTagListNormalBox get', value, value.map(item => item.title))
        return value
      },
      set(value) {
        console.log('pageTagListNormalBox set', value, value.map(item => item.title))
        this.$store.dispatch('pageTag/setPageTagListNormalBox', value)
      }
    },
    pageTagListPinBox: {
      get() {
        const value = this.$store.getters['pageTag/pageTagListPinBox']
        console.log('pageTagListPinBox get', value, value.map(item => item.title))
        return value
      },
      set(value) {
        console.log('pageTagListPinBox set', value, value.map(item => item.title))
        this.$store.dispatch('pageTag/setPageTagListPinBox', value)
      }
    },
    ...mapState('pageTag', {
      activeTagId: 'activeTagId',
      subAppDocumentClickFlag: 'subAppDocumentClickFlag',
    }),
    ...mapGetters('pageTag', {
      activeTag: 'activeTag',
      pageTagListNotCloseBox: 'pageTagListNotCloseBox',
      // pageTagListPinBox: 'pageTagListPinBox',
      // pageTagListNormalBox: 'pageTagListNormalBox',
      pageTagListMoreBox: 'pageTagListMoreBox',
      pageTagListAppendBox: 'pageTagListAppendBox',
    }),
  },
  watch: {
    subAppDocumentClickFlag(val) {
      this.isShowMoreMenu = false // hide more menu
      this.tagIdContextMenuVisible = '' // hide page tag context menu
    },
    '$store.state.pageTag.pageTags': {
      handler(newVal, oldVal) {
        this.$store.commit('pageTag/UPDATE_USER_PAGE_TAGS')
      }
    }
  },
  methods: {
    ...mapActions('pageTag', {
    }),
    handlePin(tag) {
      console.log('pin')
      pinTag(tag)
    },
    handleCancelPin(tag) {
      console.log('pin')
      cancelPinTag(tag)
    },
    handleCloseOther(tag) {
      removeOtherTags(tag)
    },
    handleSetActive(tag) {
      // if (tag.id === this.activeTagId) {
      //   return
      // }
      setActiveTagAndNavigate(tag)
      // const { url, title } = tag
      // console.log('------------- active ------------', url, title)
      // this.$sensors.setWebClick({
      //   name: `切换tag-${url}-${title}`
      // })
    },
    handleClose(tag) {
      // this.removeTag(tag)
      removePageTagAndBackward(tag)
    },
    handleRefresh(tag) {
      // 先切换为 active
      if (this.activeTagId !== tag.id) {
        setActiveTagAndNavigate(tag)
      }

      // 然后刷新
      reloadIframeByBaseAppUrl(tag.urlLatest, tag)
    },
    // 打开更多弹窗
    openMoreMenuDialog() {
      // this.isShowMoreMenu = true
    },
    initPageTagList() {
      console.log('[base-app] PageTagList mounted')
      startMicroApp({
        loader: this.subAppLoader,
      })
      // 首次打开的 url 就是 s 的场景 新添加默认页签
      // this.$store.dispatch('pageTag/initTagList')
    },
    documentClickHandler() {
      // this.isShowMoreMenu = false
    },
    updateHeaderWidth: debounce(function() {
      console.log('updateHeaderWidth', this.$refs.headerRef)
      setHeaderWidth(this.$refs.headerRef?.clientWidth)
    }, 300),
    handleMoreTagItemClick(tag) {
      this.isShowMoreMenu = false
      this.handleSetActive(tag)
    },
    turnRegistryPage() {
      this.isRegisterDialogVisible = true
      // window.open('https://kj.qizhishangke.com/user/standalone-register')
    },
    turnKnownVersion() {
      window.open('https://zsxj.yuque.com/cdy1c2/winpff/gqrpfpe0as5pob4b')
    },
    turnHelpPage() {
      window.open('https://zsxj.yuque.com/cdy1c2/winpff/wtgh9xooeegcl63c')
    }
  },
  mounted() {
    this.initPageTagList()
    this.updateHeaderWidth()
    document.addEventListener('click', this.documentClickHandler)
    window.addEventListener('resize', this.updateHeaderWidth)
  },
  destroyed() {
    document.removeEventListener('click', this.documentClickHandler)
    window.removeEventListener('resize', this.updateHeaderWidth)
  },
}
</script>

<style lang="scss" scoped>
.page-tag-wrap {
  display: flex;
  justify-content: space-between;
  height: 34px;
  background: #262F3E;
  padding-top: 4px;
  padding-left: 16px;
  padding-right: 16px;
  margin-left: -20px;
  margin-right: -20px;
  line-height: 32px;

  .direct-tag-box {
    display: flex;
    flex: 1;
    flex-direction: row;
    justify-content: flex-start;
  }

  .helper-box {
    width: 22%;
    display: flex;
    justify-content: flex-end;
    line-height: initial;

    .free-text {
      color: white;
      font-size: 13px;
      opacity: 0.9;
      line-height: 24px;
    }

    .free-use {
      height: 24px;
      padding: 4px 15px;
      margin-left: 16px;
    }

    .help-entry {
      color: white;
      font-size: 13px;
      opacity: 0.9;

      .line-icon {
        margin: 0 12px;
        line-height: 24px;
      }
    }

    .help-text {
      cursor: pointer;
      margin-right: 12px;
      line-height: 24px;
    }
  }
}

.double-arrow {
  font-size: 12px;
}

.over-time {
  margin-bottom: 4px;
  color: #313233;
}

.hover-tip {
  color: #313233;

  .el-button {
    color: blue
  }
}

.page-tag-more {
  color: #FFFFFF;
  position: relative;
  padding-right: 8px;
  padding-left: 8px;
  &::after {
    content: '';
    display: block;
    width: 1px;
    height: 14px;
    background: #616366;
    position: absolute;
    right: 0;
    top: 10px;
  }

  .menu-wrap-more {
    background: #FFFFFF;

    width: 160px;
    max-height: 260px;
    overflow: auto;
    border-radius: 2px;
  }

  .menu-wrap {

  }

  .menu-item {
    display: flex;
    justify-content: space-between;
    height: 32px;
    line-height: 32px;

    font-weight: 400;
    padding-left: 12px;
    padding-right: 12px;
    color: $G9;
    font-size: 12px;

    cursor: pointer;

    .icon-close {
      line-height: 32px;
      cursor: pointer;
      display: none;
    }

    &:hover {
      background: rgba(59,108,255,0.05);
      color: #3B6CFF;

      .icon-close {
        display: inline-block;
      }
    }
  }

  .icon-close {
    color: $G7;

    &:hover {
      color: $B6;
    }
  }

  .icon-btn-more {
    font-weight: 600;
    color: $G1;
  }
}

.icon-btn-like {
  cursor: pointer;
  color: $G7;

    &:hover {
      color: $B6;
    }
}
</style>
